import { getSearchParams } from '../utils/getSearchParams';
import { wixServerData } from '../utils/wixServerData';
import { loadBundledTranslations } from './loadBundledTranslations';

// A plain fetch is used deliberately: this is an unauthenticated GET of a
// public static asset, and the fed-sdk ResourceLoader runs outside React so it
// can't reach the app's context httpClient. Spinning up a dedicated client
// would add a redundant dependency for no benefit here.

// Opt-in logging via ?debug=true, matching the rest of the app.
const log = (level, message, data) => {
  if (getSearchParams().debug) {
    // eslint-disable-next-line no-console
    console[level](`[cdn-translations] ${message}`, data);
  }
};
const fetchTranslations = async locale => {
  const {
    translationsBaseUrl
  } = wixServerData.get();
  if (!translationsBaseUrl) {
    return loadBundledTranslations(locale);
  }
  const url = `${translationsBaseUrl}/assets/locale/messages_${locale}.json`;
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    log('info', 'loaded translations from CDN', {
      url
    });
    return await response.json();
  } catch (error) {
    log('warn', 'CDN load failed, falling back to bundled copy', {
      url,
      error
    });
    return loadBundledTranslations(locale);
  }
};

// The loader runs once per module provider, and the Eclipse page mounts several
// (main + DoublePurchase + SwitchProduct) sharing one namespace. The npm-import
// path was deduped by the bundler module cache; the CDN fetch is not, so
// memoize per locale to keep it a single request.
const cache = new Map();
export const loadPackagePickerTranslations = locale => {
  const cached = cache.get(locale);
  if (cached) {
    return cached;
  }
  const promise = fetchTranslations(locale);
  cache.set(locale, promise);
  return promise;
};
//# sourceMappingURL=loadTranslations.js.map